import Vue from 'vue';

export const GlobalEvents = {
  pageView: 'pageView',
  radiusCheck: 'radiusCheck',
};

export default new Vue({
  name: 'GlobalEventBus',

  methods: {
    emitPageViewEvent(payload) {
      this.$emit(GlobalEvents.pageView, payload);
    },
  },
});
